@if (!isFormShown()) {
    <big-a11y-tab-nav class="fixed left-2 top-2 z-(--z-modal)" />
}

<ngx-loading-bar
    [color]="isFormShown() ? 'var(--color-primary)' : 'var(--color-primary-50)'"
    height="3px"
    [includeSpinner]="false" />

@if (!isFormShown()) {
    <big-ui-top-bar
        (bigSharedResized)="onTopBarResized($event)"
        class="sticky top-0 left-0 right-0"
        [items]="topBars()!" />

    <!-- We can not use transloco here because it causes unreproducable issues with ssr modus -->
    <!-- Check BIGDEV-3562 for more info -->
    <big-nav-header
        [headerContext]="{
            loggedInText: 'meineBIG',
            loggedOutText: 'meineBIG',
        }"
        (bigSharedResized)="onHeaderResized($event)"
        class="sticky left-0 right-0 z-(--z-fixed)"
        [ngStyle]="{
            'top.px': topBarSize().height,
        }">
        <big-ui-link
            [linkClass]="'after:content-none'"
            navLogoContent
            href="/">
            <big-ui-company-logo />
        </big-ui-link>
    </big-nav-header>
}

<big-nav-sidenav>
    <main>
        <router-outlet [id]="mainContent.key" />
    </main>

    @if (!isFormShown()) {
        <big-footer
            [id]="footer.key"
            class="mt-16 md:mt-20 lg:mt-30" />
        <big-chat />
        <big-chat-toggle />
    }
</big-nav-sidenav>
